import { AnimatedBanner } from "@faire/deprecated-retailer-visitor-shared/components/AnimatedBanner/AnimatedBanner";
import { ImpBanner } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/PromoBanner/__internal__/ImpBanner";
import {
  BannerContent,
  BannerSectionWithKeyAndContent,
} from "@faire/deprecated-retailer-visitor-shared/components/Notifications/PromoBanner/__internal__/siteBannersConsts";
import { ConductorBanner } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/PromoBanner/ConductorBanner";
import { IConductorComponentData } from "@faire/deprecated-retailer-visitor-shared/features/Conductor/types";
import { Decorative } from "@faire/design-tokens";
import { IProductMessageByViewport } from "@faire/web-api--source/indigofair/retailer/IProductMessageByViewport";
import { isNotNull } from "@faire/web/common/typescriptUtils";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React, { isValidElement } from "react";
import styled from "styled-components";

interface IProps {
  banners: BannerSectionWithKeyAndContent;
}

// Hacky way to check if the banner content type based on custom interfaces
const isConductorInterface = (bannerContent: BannerContent) => {
  return (
    bannerContent !== null &&
    typeof bannerContent === "object" &&
    ("conductorSduiViewLayout" in bannerContent ||
      "conductorBuilderModelName" in bannerContent)
  );
};

const isProductMessageByViewportInterface = (bannerContent: BannerContent) => {
  return (
    bannerContent !== null &&
    typeof bannerContent === "object" &&
    "mobile_and_above" in bannerContent
  );
};

// This assumes that all banners are merged in the right order
// and this tool is used to render them. If conductor does not return
// any banners, we'll fall back to the PromoBanners component.
export const MixedPromoBanners: React.FC<IProps> = ({ banners }) => {
  const bannerNames: string[] = [];
  const bannerComponents = banners
    .map((banner, i) => {
      const bannerKey = Object.keys(banner)[0];
      const bannerContent = Object.values(banner)[0] as BannerContent;

      if (!bannerKey || !bannerContent) {
        return null;
      }

      bannerNames.push(bannerKey);

      switch (true) {
        // For now, Conductor only returns ViewLayout for FOI
        // We can cheat a little and just render the ConductorBanner directly
        case isConductorInterface(bannerContent):
          return (
            <ConductorBanner
              key={i}
              overrideViewLayout={
                (bannerContent as IConductorComponentData)
                  .conductorSduiViewLayout
              }
            />
          );
        case isProductMessageByViewportInterface(bannerContent):
          return (
            <ImpBanner
              key={i}
              banner={bannerContent as IProductMessageByViewport}
            />
          );
        case isValidElement(bannerContent):
          return bannerContent;
        default:
          return null;
      }
    })
    .filter(isNotNull);

  return (
    <StyledAnimatedBanner
      banners={bannerComponents}
      bannerNames={bannerNames}
    />
  );
};

const StyledAnimatedBanner = styled(AnimatedBanner)`
  background-color: ${Decorative.tint.neutral};
  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing(6, 4)};
  }
`;
